module.exports = __webpack_public_path__ + "static/img/Groningen.2edbb57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Groningen.jpg
// module id = aSoF
// module chunks = 1